import { render, staticRenderFns } from "./SimilarCandidatesList.vue?vue&type=template&id=361067bc&scoped=true&"
import script from "./SimilarCandidatesList.vue?vue&type=script&lang=ts&"
export * from "./SimilarCandidatesList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361067bc",
  null
  
)

export default component.exports